/** @jsx jsx */
import { jsx } from '@emotion/core'
import { HFlow, Icon, InfoLabel, VFlow } from 'bold-ui'
import { format } from 'date-fns'

import { HLabel } from '../../../../../../components/HLabel'
import { EvolucaoProblema } from '../../../soap/aside/types/ProblemaModel'
import { SituacaoProblemaTag } from '../../SituacaoProblemaTag'
import { formatDate } from './AccordionProblemasModal'

export type BodyProblemaModalProps = {
  evolucaoProblema: EvolucaoProblema
}

export function BodyProblemaModal(props: BodyProblemaModalProps) {
  const { evolucaoProblema } = props

  return (
    <VFlow>
      <HFlow alignItems='center'>
        <Icon icon='calendarFilled' fill='info' size={1} />
        {!!evolucaoProblema.atualizadoEm
          ? format(new Date(evolucaoProblema.atualizadoEm), 'DD/MM/YYYY [às] HH:mm')
          : 'Atendimento atual'}
        <SituacaoProblemaTag situacao={evolucaoProblema.situacao} />
      </HFlow>
      <HFlow justifyContent='space-between'>
        <InfoLabel title='Observações'>{evolucaoProblema.observacao}</InfoLabel>
        <HFlow>
          <InfoLabel title='Data de início'>{formatDate(evolucaoProblema.dataInicio)}</InfoLabel>
          <InfoLabel title='Data de fim'>{formatDate(evolucaoProblema.dataFim)}</InfoLabel>
        </HFlow>
      </HFlow>
      {evolucaoProblema.atendimentoProfissional && (
        <HLabel title='Evoluído por: '>
          {evolucaoProblema.atendimentoProfissional.lotacao.profissional.nome.titleCase()}
          {' - '}
          {evolucaoProblema.atendimentoProfissional.lotacao.cbo.nome.capitalize()}
        </HLabel>
      )}
    </VFlow>
  )
}
